import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import ChatButton from "../components/ChatButton";
import { Helmet } from "react-helmet-async";

const formatNumber = (num) => {
  if (num === 0) return "0";
  const units = ["", "K", "M", "B", "T"];
  let unitIndex = 0;
  let n = num;

  while (n >= 1000 && unitIndex < units.length - 1) {
    n /= 1000;
    unitIndex++;
  }

  const formatted = n >= 100 || n % 1 === 0 ? n.toFixed(0) : n.toFixed(1);
  return `${formatted}${units[unitIndex]}`;
};

const MostVisited = () => {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const timestamp = new Date().getTime();
        const res = await fetch(
          `https://www.pixelliongroup.com/seotic/ranked_domains.json?t=${timestamp}`
        );
        if (!res.ok) {
          throw new Error("Failed to fetch ranked domains");
        }
        const data = await res.json();
        setDomains(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDomains();
  }, []);

  // 🟢 Skeleton rows (e.g. 10 placeholders)
  const SkeletonRows = () => (
    <tbody>
      {Array.from({ length: 10 }).map((_, idx) => (
        <tr key={idx} className="border-b border-slate-200 bg-white animate-pulse">
          <td className="py-4 px-7">
            <div className="h-4 w-6 bg-slate-200 rounded"></div>
          </td>
          <td className="p-4 flex items-center space-x-2">
            <div className="h-8 w-8 bg-slate-200 rounded"></div>
            <div className="h-4 w-32 bg-slate-200 rounded"></div>
          </td>
          <td className="p-4">
            <div className="h-4 w-16 bg-slate-200 rounded"></div>
          </td>
          <td className="p-4">
            <div className="h-4 w-20 bg-slate-200 rounded"></div>
          </td>
        </tr>
      ))}
    </tbody>
  );

  if (error) {
    return (
      <>
        <Navbar />
        <p className="text-center text-red-500 mt-10">Error: {error}</p>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Most Visited Websites - Seotic</title>
        <meta
          name="description"
          content="List of the most visited websites based on external data."
        />
      </Helmet>

      <Navbar />

      <div className="bg-gradient-to-t from-slate-100 to-white h-full">
        <div className="container mx-auto py-12 px-2 md:px-0">
          <h2 className="text-center text-base/7 uppercase text-slate-400">
            August 2025
          </h2>
          <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
            Top 100, Most Visited Websites in the World
          </p>

          <section className="max-w-6xl mx-auto mb-10 mt-20 border border-slate-200 rounded-lg ">
            <div className="overflow-x-auto">
              <table className="min-w-full text-left">
                <thead>
                  <tr className="border-b bg-yellow-50 border-slate-200 uppercase">
                    <th className="py-4 px-7 rounded-tl-lg">Rank</th>
                    <th className="p-4">Website</th>
                    <th className="p-4">Keywords</th>
                    <th className="p-4 rounded-tr-lg">Traffic</th>
                  </tr>
                </thead>

                {loading ? (
                  <SkeletonRows />
                ) : (
                  <tbody>
                    {domains.map((d) => (
                      <tr
                        key={d.position}
                        className="border-b border-slate-200 rounded-lg bg-white"
                      >
                        <td className="py-4 px-7 text-slate-400">
                          {d.position}
                        </td>
                        <td className="p-4 flex items-center">
                          <img
                            className="mr-2 rounded"
                            src={`https://www.google.com/s2/favicons?domain=${d.domain}`}
                            alt={d.domain}
                          />
                          <a
                            href={`https://www.${d.domain}?ref=seotic.co`}
                            title={d.domain}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {d.domain}
                          </a>
                        </td>
                        <td className="p-4">{formatNumber(d.count)}</td>
                        <td className="p-4">{formatNumber(d.etv)}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </section>
        </div>
      </div>

      <Faq />
      <Footer />
    </>
  );
};

export default MostVisited;
